import React, { useState, useEffect } from 'react';
import ClockLoader from 'react-spinners/ClockLoader';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Row, Col } from 'react-bootstrap';
import { Typography } from '@mui/material';

export default function Review({ formData, loading }) {
  function DateFormat(dateString) {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return dateString;
    }
    // const options = { month: 'short', day: 'numeric', year: 'numeric' };

    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
    const day = new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format(date);
    const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(date);
    return `${day}-${month}-${year}`;
  }

  function AmountFormat(amount) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2, // Adjust as needed
    }).format(amount);
  }

  const [localData, setLocalData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    acn: '',
    dob: '',
    appEmail: '',
    address: '',
    city: '',
    state: '',
    district: '',
    pincode: '',
    usvName: '',
    usvPhone: '',
    usvEmail: '',
    ivName: '',
    ivEmail: '',
    ivPhone: '',
    relationToApplicant: '',
  });

  useEffect(() => {
    // const myData = localStorage.getItem('myUsaDatastep1');
    const storedDataString = localStorage.getItem('myUsaDatastep1');
    const storedDataVolunteersDetail = localStorage.getItem('volunteersDetail');
    if (storedDataString) {
      const storedData = JSON.parse(storedDataString);
      const volunteersDetails = JSON.parse(storedDataVolunteersDetail);
      setLocalData({
        firstName: storedData.step1.firstName,
        lastName: storedData.step1.lastName,
        phoneNumber: storedData.step1.phoneNumber,
        acn: storedData.step1.aadharNumber,
        dob: storedData.step1.dateOfBirth,
        appEmail: storedData.step1.appEmail,
        address: storedData.step1.addressone,
        city: storedData.step1.city,
        state: storedData.step1.state,
        district: storedData.step1.district,
        pincode: storedData.step1.pincode,
        usvName: volunteersDetails.volunteersDetail.usvname,
        usvPhone: volunteersDetails.volunteersDetail.usvphone,
        usvEmail: volunteersDetails.volunteersDetail.usvemail,
        ivName: volunteersDetails.volunteersDetail.ivname,
        ivEmail: volunteersDetails.volunteersDetail.ivemail,
        ...(volunteersDetails.volunteersDetail.ivphone && { ivPhone: volunteersDetails.volunteersDetail.ivphone }),
        ...(volunteersDetails.volunteersDetail.ivTelephone && { ivPhone: volunteersDetails.volunteersDetail.ivTelephone }),
        relationToApplicant: volunteersDetails.volunteersDetail.relationtoapplicant,
      });
    }
  }, []);

  return (
    <>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <ClockLoader color="#1976d2" loading={loading} size={150} aria-label="Loading Spinner" data-testid="loader" />
        </div>
      ) : (
        <>
          {/* first section */}
          <section className="border-top border-bottom p-2">
            <Typography
              sx={{
                marginBottom: '-5px',
                marginTop: '-22px',
              }}
              className="text-center"
            >
              <label
                className="fw-semibold"
                style={{
                  backgroundColor: 'white',
                  color: '#ce690a',
                  fontSize: '17px',
                }}
              >
                USA Voluteer Details
              </label>
            </Typography>
            <Row className="mt-3">
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Volunteer Name
                </label>
                <p className="fs-6 text-muted fw-semibold ">{localData.usvName}</p>
              </Col>
              <Col md={2} sm={6} style={{ width: '300px' }}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Volunteer Email
                </label>
                <p className="fs-6 text-muted fw-semibold">{localData.usvEmail}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Volunteer Phone
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{localData.usvPhone}</p>
              </Col>
            </Row>
          </section>
          {/* second section */}
          <section className="border-bottom p-2">
            <Typography
              sx={{
                marginBottom: '-5px',
                marginTop: '-22px',
              }}
              className="text-center"
            >
              <label
                className="fw-semibold"
                style={{
                  backgroundColor: 'white',
                  color: '#ce690a',
                  fontSize: '17px',
                }}
              >
                Indian Reference Details
              </label>
            </Typography>
            <Row className="mt-3">
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Referral Name
                </label>
                <p className="fs-6 text-muted fw-semibold ">{localData.ivName}</p>
              </Col>
              <Col md={2} sm={6} style={{ width: '300px' }}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Referral Email
                </label>
                <p className="fs-6 text-muted fw-semibold">{localData.ivEmail}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Referral Phone
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{localData.ivPhone}</p>
              </Col>
              <Col md={4} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Relationship with Referral
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{localData.relationToApplicant}</p>
              </Col>
            </Row>
          </section>
          <section className="border-top border-bottom p-2">
            <Typography
              sx={{
                marginBottom: '-5px',
                marginTop: '-22px',
              }}
              className="text-center"
            >
              <label
                className="fw-semibold"
                style={{
                  backgroundColor: 'white',
                  color: '#ce690a',
                  fontSize: '17px',
                }}
              >
                Applicant Details
              </label>
            </Typography>
            <Row className="mt-3">
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  First Name
                </label>
                <p className="fs-6 text-muted fw-semibold ">{formData.firstName ? formData.firstName : localData.firstName}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Last Name
                </label>
                <p className="fs-6 text-muted fw-semibold">{formData.lastName ? formData.lastName : localData.lastName}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Aadhar Number
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.aadharNumber ? formData.aadharNumber : localData.acn}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Date of Birth
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{DateFormat(formData.dob ? formData.dob : localData.dob)}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Email
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.email ? formData.email : localData.appEmail}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Phone Number
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.phonenumber ? formData.phonenumber : localData.phoneNumber}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Address
                </label>
                <p className="fs-6 text-muted fw-semibold">{formData.address ? formData.address : localData.address}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  City
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.city ? formData.city : localData.city}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  State
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.state ? formData.state : localData.state}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  District
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.district ? formData.district : localData.district}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Pincode
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.zip ? formData.zip : localData.pincode}</p>
              </Col>
            </Row>
          </section>
          {/* //second section */}
          <section className="border-bottom p-2">
            <Typography
              sx={{
                marginBottom: '-5px',
                marginTop: '-22px',
              }}
              className="text-center"
            >
              <label
                className="fw-semibold"
                style={{
                  backgroundColor: 'white',
                  color: '#ce690a',
                  fontSize: '17px',
                }}
              >
                Parent/Guardian Details
              </label>
            </Typography>
            <Row className="mt-3">
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Father Name
                </label>
                <p className="fs-6 text-muted fw-semibold ">{formData.fatherName}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Father Occupation
                </label>
                <p className="fs-6 text-muted fw-semibold">{formData.fatherOccupation}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Mother Name
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.motherName}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Mother Occupation
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.motherOccupation}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Family Income
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{AmountFormat(formData.familyIncome)}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Family Members
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.familyCount}</p>
              </Col>
            </Row>
          </section>
          {/* aid request */}
          <Typography
            sx={{
              marginBottom: '-5px',
              marginTop: '-15px',
            }}
            className="text-center"
          >
            <label
              className="fw-semibold"
              style={{
                backgroundColor: 'white',
                color: '#ce690a',
                fontSize: '17px',
              }}
            >
              Aid Request Details
            </label>
          </Typography>
          <section className="border-bottom p-2">
            <Row className="mt-3">
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Aid Request Amount
                </label>
                <p className="fs-6 text-muted fw-semibold ">{AmountFormat(formData.amountRequested)}</p>
              </Col>
              <Col md={2} sm={6} style={{ width: '300px' }}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Course Type
                </label>
                <p className="fs-6 text-muted fw-semibold">{formData.courseType}</p>
              </Col>
              <Col md={2} sm={6} style={{ width: '300px' }}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Course
                </label>
                <p className="fs-6 text-muted fw-semibold">{formData.aidtype}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Aid Request Reason
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.reasonForRequesting}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Multiple Year Request
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.multipleyears}</p>
              </Col>
              {formData.multipleyears === 'yes' ? (
                <Col md={2} sm={6}>
                  <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                    No.Of.Years Support
                  </label>
                  <p className="fs-6 text-muted fw-semibold text-wrap">{formData.yearsofsupportisneeded}</p>
                </Col>
              ) : null}
            </Row>
          </section>

          {/* fifth section */}
          <Typography
            sx={{
              marginBottom: '-5px',
              marginTop: '-15px',
            }}
            className="text-center"
          >
            <label
              className="fw-semibold"
              style={{
                backgroundColor: 'white',
                color: '#ce690a',
                fontSize: '17px',
              }}
            >
              Institution Details
            </label>
          </Typography>
          <section className="border-bottom p-2">
            <Row className="mt-3">
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Institution Name
                </label>
                <p className="fs-6 text-muted fw-semibold ">{formData.institutionName}</p>
              </Col>

              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Email
                </label>
                <p className="fs-6 text-muted fw-semibold ">{formData.institutionEmail}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  MobileNumber
                </label>
                <p className="fs-6 text-muted fw-semibold ">{formData.institutionMobileNumber}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Address
                </label>
                <p className="fs-6 text-muted fw-semibold">{formData.institutionAddress}</p>
              </Col>
              <Col md={1} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  City
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.institutionCity}</p>
              </Col>
              <Col md={1} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  State
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.institutionState}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  District
                </label>
                <p className="fs-6 text-muted fw-semibold ">{formData.institutiondistrict}</p>
              </Col>
              <Col md={1} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Pincode
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.institutionZip}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Beneficary Name
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.beneficiaryName}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Beneficary Phone
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.beneficiaryPhone}</p>
              </Col>
            </Row>
          </section>
          <Typography
            sx={{
              marginBottom: '-5px',
              marginTop: '-15px',
            }}
            className="text-center"
          >
            <label
              className="fw-semibold"
              style={{
                backgroundColor: 'white',
                color: '#ce690a',
                fontSize: '17px',
              }}
            >
              Payment Details
            </label>
          </Typography>
          <section className="border-bottom p-2">
            <Row className="mt-3">
              {/* payment */}
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Account Number
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.accountNumber}</p>
              </Col>
              <Col md={1} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  IFSC Code
                </label>
                <p className="fs-6 text-muted fw-semibold text-break">{formData.ifscCode}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Bank Name
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.bankName}</p>
              </Col>
              <Col md={2} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Branch Name
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.branchName}</p>
              </Col>
              <Col md={3} sm={6}>
                <label className="text-primary fw-semibold" style={{ fontSize: '17px' }}>
                  Branch Address
                </label>
                <p className="fs-6 text-muted fw-semibold text-wrap">{formData.paymentAddress}</p>
              </Col>
            </Row>
          </section>
        </>
      )}
    </>
  );
}
